import EnvironmentSettings from "../../Models/EnvironmentSettings";
import TenantManager from "../TenantManager";
import UsersApi from "../UsersApi";

class SessionsApi {
  constructor() {
    EnvironmentSettings.Environment === "dev"
      ? (this.baseUrl = EnvironmentSettings.LocalUrl)
      : (this.baseUrl = EnvironmentSettings.LiveUrl);
    //console.log("baseUrl: ", this.baseUrl);
  }

  //*************** Sessions ***********************************

  CreateSessionUrl = "Admin/CreateSession";
  CreateChildSessionUrl = "Admin/CreateChildSession";
  EditSessionUrl = "Admin/EditSession";
  DeleteSessionUrl = "Admin/DeleteSession";
  GetSessionByIdUrl = "Admin/GetSessionById";
  SearchSessionsUrl = "Admin/SearchSessions";

  async CreateSession(req, setErrorText) {
    // let form = new FormData();
    // form.append("Id", req.Id);
    // form.append("Name", req.Name);

    // form.append("Description", req.Description);
    // form.append("Category", req.Category);
    // form.append("SecretName", req.SecretName);
    // form.append("EgyptianPrice", req.EgyptianPrice);
    // form.append("ArabPrice", req.ArabPrice);
    // form.append("OtherPrice", req.OtherPrice);
    // form.append("IsHalfDuration", req.IsHalfDuration);
    // form.append("IsAssessmentSession", req.IsAssessmentSession);
    // form.append("IsContractSession", req.IsContractSession);
    // form.append("ContractId", req.ContractId);
    // form.append("ParentSessionId", req.ParentSessionId);

    // if (req.Image.files.length > 0) {
    //   for (var index = 0; index < req.Image.files.length; index++) {
    //     if (!this.isFileImage(req.Image.files[index])) {
    //       setErrorText("Please upload valid image files only");
    //       return;
    //     }

    //     var element = req.Image.files[index];
    //     // Images.push(element);
    //     form.append("Image", element);
    //   }
    // }

    const res = await fetch(this.baseUrl + this.CreateSessionUrl, {
      method: "POST",
      body: JSON.stringify(req),
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        "Content-type": "application/json",
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
      },
    });

    const data = await res.json();
    console.log(data);

    return data;
  }

  async CreateChildSession(req) {
    let form = new FormData();
    form.append("ParentSessionId", req.ParentSessionId);
    form.append("ContractId", req.ContractId);

    const res = await fetch(this.baseUrl + this.CreateChildSessionUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        // 'Content-type': 'application/json'
      },
      body: form,
    });

    const data = await res.json();
    console.log(data);

    return data;
  }
  async EditSession(req) {
    req.Image = undefined;
    const res = await fetch(this.baseUrl + this.EditSessionUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async GetSessionById(req) {
    req.Image = undefined;
    const res = await fetch(this.baseUrl + this.GetSessionByIdUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async DeleteSession(req) {
    const res = await fetch(this.baseUrl + this.DeleteSessionUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async SearchSessions(req) {
    const res = await fetch(this.baseUrl + this.SearchSessionsUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  isFileImage(file) {
    return file && file["type"].split("/")[0] === "image";
  }

  //******************* Session Facility Types *************************** */

  AddFacilityTypeToSessionUrl = "Admin/AddFacilityTypeToSession";
  RemoveFacilityTypeFromSessionUrl = "Admin/RemoveFacilityTypeFromSession";
  AddTherapistTypeToSessionUrl = "Admin/AddTherapistTypeToSession";
  RemoveTherapistTypeFromSessionUrl = "Admin/RemoveTherapistTypeFromSession";

  async AddFacilityTypeToSession(req) {
    const res = await fetch(this.baseUrl + this.AddFacilityTypeToSessionUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async RemoveFacilityTypeFromSession(req) {
    const res = await fetch(this.baseUrl + this.RemoveFacilityTypeFromSessionUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async AddTherapistTypeToSession(req) {
    const res = await fetch(this.baseUrl + this.AddTherapistTypeToSessionUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async RemoveTherapistTypeFromSession(req) {
    const res = await fetch(this.baseUrl + this.RemoveTherapistTypeFromSessionUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  //*****************************ACCOUNTING SESSIONS*********************************** */
  CreateAccountingSessionUrl = "Accounting/CreateAccountingSession";
  EditAccountingSessionUrl = "Accounting/EditAccountingSession";
  DeleteAccountingSessionUrl = "Accounting/DeleteAccountingSession";
  GetAccountingSessionByIdUrl = "Accounting/GetAccountingSessionById";
  SearchAccountingSessionsUrl = "Accounting/SearchAccountingSessions";
  ToggleAccountingSessionAdmissionUrl = "Accounting/ToggleAccountingSessionAdmission";
  ToggleAccountingSessionIsExcteptionUrl = "Accounting/ToggleAccountingSessionIsException";
  ToggleAccountingSessionIsAbsentUrl = "Accounting/ToggleAccountingSessionIsAbsent";

  GetTherapistAccountingSessionsUrl = "Accounting/GetTherapistAccountingSessions";

  AddTherapistToAccountingSessionUrl = "Accounting/AddTherapistToAccountingSession";
  RemoveTherapistFromAccountingSessionUrl = "Accounting/RemoveTherapistFromAccountingSession";

  AddFacilityToAccountingSessionUrl = "Accounting/AddFacilityToAccountingSession";
  RemoveFacilityFromAccountingSessionUrl = "Accounting/RemoveFacilityFromAccountingSession";

  CreatePatientHistoryUrl = "Admin/CreatePatientHistoryEntry";
  DownloadHistoryFileUrl = "Admin/DownloadHistoryFile";

  async DownloadHistoryFile(req) {
    const res = await fetch(this.baseUrl + this.DownloadHistoryFileUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.blob();
    console.log(data);
    return data;
  }

  async CreatePatientHistoryEntry(Notes, FilesInput, Session, TherapistId) {
    let form = new FormData();
    form.append("Notes", Notes);
    form.append("PatientId", Session.getPatient.id);
    form.append("AccountingSessionId", Session.id);
    form.append("TherapistId", TherapistId);

    var files = [];
    if (FilesInput.files.length > 0) {
      for (var index = 0; index < FilesInput.files.length; index++) {
        var element = FilesInput.files[index];
        // Images.push(element);
        files.push(element);
        form.append("Files", element);
      }
    }

    const res = await fetch(this.baseUrl + this.CreatePatientHistoryUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        // 'Content-type': 'application/json'
      },
      body: form,
    });

    const data = await res.json();
    console.log(data);

    return data;
  }

  // async CreatePatientHistoryEntry2(Notes, FilesInput, userId, TherapistId, accountingSessionId) {

  //   let form = new FormData();
  //   form.append('Notes', Notes);
  //   form.append('PatientId', userId);
  //   form.append('TherapistId', TherapistId);
  //   form.append('AccountingSessionId', accountingSessionId);

  //   var files = [];
  //   if (FilesInput.files.length > 0) {
  //     for (var index = 0; index < FilesInput.files.length; index++) {

  //       var element = FilesInput.files[index];
  //       // Images.push(element);
  //       files.push(element);
  //       form.append('Files', element);
  //     }
  //   }

  //   const res = await fetch(this.baseUrl + this.CreatePatientHistoryUrl, {
  //     method: 'POST',
  //     headers: {
  //       Authorization: `Bearer ${UsersApi.GetToken()}`,
  // tenant: TenantManager.getTenant(UsersApi.GetToken()),
  //       // 'Content-type': 'application/json'
  //     },
  //     body: form
  //   })

  //   const data = await res.json();
  //   console.log(data)

  //   return data;
  // }

  async CreatePatientHistoryEntry2(req) {
    const res = await fetch(this.baseUrl + this.CreatePatientHistoryUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);

    return data;
  }

  async CreateAccountingSession(req) {
    const res = await fetch(this.baseUrl + this.CreateAccountingSessionUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async EditAccountingSession(req) {
    const res = await fetch(this.baseUrl + this.EditAccountingSessionUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async DeleteAccountingSession(req) {
    const res = await fetch(this.baseUrl + this.DeleteAccountingSessionUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async GetAccountingSessionById(req) {
    const res = await fetch(this.baseUrl + this.GetAccountingSessionByIdUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async SearchAccountingSessions(req) {
    const res = await fetch(this.baseUrl + this.SearchAccountingSessionsUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async ToggleAccountingSessionIsAbsent(req) {
    const res = await fetch(this.baseUrl + this.ToggleAccountingSessionIsAbsentUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async ToggleAccountingSessionIsExcteption(req) {
    const res = await fetch(this.baseUrl + this.ToggleAccountingSessionIsExcteptionUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async ToggleAccountingSessionAdmission(req) {
    const res = await fetch(this.baseUrl + this.ToggleAccountingSessionAdmissionUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async ToggleSessionAddmission(req) {
    const res = await fetch(this.baseUrl + this.ToggleSessionAddmission, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async GetTherapistAccountingSessions(req) {
    const res = await fetch(this.baseUrl + this.GetTherapistAccountingSessionsUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  GetPatientAccountingSessionsUrl = "Accounting/GetPatientAccountingSessions";

  async GetPatientAccountingSessions(req) {
    const res = await fetch(this.baseUrl + this.GetPatientAccountingSessionsUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async AddTherapistToAccountingSession(req) {
    const res = await fetch(this.baseUrl + this.AddTherapistToAccountingSessionUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async RemoveTherapistFromAccountingSession(req) {
    const res = await fetch(this.baseUrl + this.RemoveTherapistFromAccountingSessionUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async AddFacilityToAccountingSession(req) {
    const res = await fetch(this.baseUrl + this.AddFacilityToAccountingSessionUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async RemoveFacilityFromAccountingSession(req) {
    const res = await fetch(this.baseUrl + this.RemoveFacilityFromAccountingSessionUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  //*****************************Packages*********************************** */
  CreatePackageUrl = "Admin/CreatePackage";
  UpdatePackageNotesAndStartDateUrl = "Admin/UpdatePackageNotesAndStartDate";
  AddAccountingSessionsToPackageUrl = "Admin/AddAccountingSessionsToPackage";
  CreateMultiPackageUrl = "Admin/CreateMultiPackage";
  EditPackageUrl = "Admin/EditPackage";
  DeletePackageUrl = "Admin/DeletePackage";
  GetPackageByIdUrl = "Admin/GetPackageById";
  SearchPackagesUrl = "Admin/SearchPackages";

  async AddAccountingSessionsToPackage(req) {
    const res = await fetch(this.baseUrl + this.AddAccountingSessionsToPackageUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async CreateMultiPackage(req) {
    const res = await fetch(this.baseUrl + this.CreateMultiPackageUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async CreatePackage(req) {
    const res = await fetch(this.baseUrl + this.CreatePackageUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async UpdatePackageNotesAndStartDate(req) {
    const res = await fetch(this.baseUrl + this.UpdatePackageNotesAndStartDateUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();

    return data;
  }
  async EditPackage(req) {
    const res = await fetch(this.baseUrl + this.EditPackageUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async DeletePackage(req) {
    const res = await fetch(this.baseUrl + this.DeletePackageUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async GetPackageById(req) {
    const res = await fetch(this.baseUrl + this.GetPackageByIdUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async SearchPackages(req) {
    const res = await fetch(this.baseUrl + this.SearchPackagesUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }
}

export default new SessionsApi();
